import * as React from 'react';
import { observer } from 'mobx-react';
import { Col, Row } from 'antd';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { StatusTexts } from "src/app/shared/status-texts";

interface QuoteEntryStatusSimpleConditionProps {
	onFieldChange: (field: string, value: any) => void;
	values?: { [id: string]: any };
	mode: ControlMode;
}

@observer
export class QuoteEntryStatusSimpleCondition extends React.Component<QuoteEntryStatusSimpleConditionProps, any> {
	constructor(props) {
		super(props);

	}

	render() {

		const { values } = this.props;

		const comboValues = [
			{ text: StatusTexts.getQuoteEntryStatusFromNumber(0), value: '0' },
			{ text: StatusTexts.getQuoteEntryStatusFromNumber(1), value: '1' },
			{ text: StatusTexts.getQuoteEntryStatusFromNumber(2), value: '2' },
			{ text: StatusTexts.getQuoteEntryStatusFromNumber(3), value: '3' },
			{ text: StatusTexts.getQuoteEntryStatusFromNumber(4), value: '4' },
			{ text: StatusTexts.getQuoteEntryStatusFromNumber(5), value: '5' },
			{ text: StatusTexts.getQuoteEntryStatusFromNumber(6), value: '6' },
		];
			
		return (
			<React.Fragment>
				<div>

					<p style={{ margin: '7px' }}
					>Return true if the event status is equal to combo value</p>


					<Row gutter={24}>
						<Col xs={12}>
							<DropdownView
								label='Status value'
								model={values && values["status"]}
								disabled={this.props.mode == 'display'}
								onChanged={(e) => this.props.onFieldChange("status", e.value)}
								options={comboValues}
								keyField='value'
								textField='text'
							/>
						</Col>
					</Row>
				</div>



			</React.Fragment>);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/form/parts/conditions/quote-entry-current-status.condition.tsx